import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMilibooPimMin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1080 1080",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		fill: "#cd786c",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1080,
			height: 1080,
			rx: 81.82,
			ry: 81.82
		})
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "M",
			d: "M762.69,638.97v-296.57c0-21.84-8.36-41.12-25.32-57.73-16.84-16.61-36.36-24.98-58.43-24.98s-59.24,9.18-99.44,27.65c6.39,18.94,9.64,37.41,9.64,55.18v296.57h-92.58v-295.99c.7-21.84-7.67-41.12-24.28-57.73-16.61-16.61-36.24-24.98-58.55-24.98s-59.48,8.02-96.42,24.16v360.35h-98.28V234.25l98.97-35.31c39.73-12.66,73.3-18.94,100.83-18.94,45.42,0,84.1,13.48,116.4,40.54,68.89-26.95,119.54-40.54,151.71-40.54,48.79,0,89.91,15.8,123.25,47.4,33.34,31.6,49.95,70.05,50.76,115.47v295.99h-98.28v.12h0Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", { d: "M220.1,899.2v-196h76.44c17.17,0,31.82,2.71,43.96,8.12,12.13,5.42,21.46,13.26,28,23.52,6.53,10.27,9.8,22.5,9.8,36.68s-3.27,26.37-9.8,36.54c-6.54,10.18-15.87,18.02-28,23.52-12.14,5.51-26.79,8.26-43.96,8.26h-61.04l12.6-13.16v72.52h-28ZM248.1,829.48l-12.6-14h60.2c17.92,0,31.5-3.82,40.74-11.48,9.24-7.65,13.86-18.48,13.86-32.48s-4.62-24.82-13.86-32.48c-9.24-7.65-22.82-11.48-40.74-11.48h-60.2l12.6-14v115.92Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M492.26,899.2v-196h28v196h-28Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M651.86,899.2v-196h22.96l87.92,148.12h-12.32l86.8-148.12h22.96l.28,196h-26.88l-.28-153.72h6.44l-77.28,129.92h-12.88l-77.84-129.92h7v153.72h-26.88Z" })
		] })]
	})]
});
export default SvgMilibooPimMin;
